export default __webpack_public_path__ + "static/media/loser.6a8077aa.gif";